/**
 * The three portals a review user can hold, in one place (05-10-2026).
 *
 * The reviewer sidebar, the per-portal request pages and the dashboard
 * analytics all name the same portals; keeping the list here stops the three
 * from drifting. `portal` is the value the backend stores on a request,
 * `slug` the URL segment.
 */
export const PORTAL_PAGES = [
  { slug: "income-tax", portal: "income_tax", label: "Income Tax" },
  { slug: "gst", portal: "gst", label: "GST" },
  { slug: "tds", portal: "tds", label: "TDS" },
];

export const portalBySlug = (slug) =>
  PORTAL_PAGES.find((p) => p.slug === slug) || null;

/** Display name for a stored portal value, e.g. "income_tax" -> "Income Tax". */
export const portalLabel = (portal) =>
  PORTAL_PAGES.find((p) => p.portal === portal)?.label || portal;
